import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Actions from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import {
  selectCurrentProject,
  selectCurrentSamples,
  selectParticipantsByProjectId,
  selectProjectOrders
} from 'Flux/Selector/Project/ProjectSelectors.js'
import { ProjectView } from './ProjectView.js'
import { trackProjectAction } from 'Services/Telemetry/index.js'

export function ProjectParamLoaderView() {
  const { id } = useParams()
  const dispatch = useDispatch()
  const project = useSelector(selectCurrentProject)
  const samples = useSelector(selectCurrentSamples)
  const participants = useSelector(id ? selectParticipantsByProjectId(id) : () => [])
  const orders = useSelector(selectProjectOrders)

  useEffect(() => {
    dispatch(Actions[projectSlice.name].reset())
    if (id) {
      dispatch(Actions[projectSlice.name].getProjectRequest({ projectId: id }))
      dispatch(Actions[projectSlice.name].getParticipantsRequest({ projectId: id }))
      dispatch(Actions[projectSlice.name].getProjectSamplesRequest({ projectId: id }))
      dispatch(Actions[projectSlice.name].loadProjectOrdersRequest({ projectId: id }))
    }
  }, [dispatch, id])

  // Project reach. Mirrors `order.page_view`: `reason` separates a first visit from a revisit, so a
  // project that is created once and worked in daily is distinguishable from one that is abandoned
  // right after creation — which the slice-only events could never tell us.
  useEffect(() => {
    if (!id) return
    const viewKey = `project-viewed-${id}`
    const wasViewed = typeof sessionStorage !== 'undefined' && sessionStorage.getItem(viewKey) === '1'
    trackProjectAction('opened', id, { reason: wasViewed ? 'reopen' : 'initial' })
    if (!wasViewed && typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem(viewKey, '1')
    }
  }, [id])

  if (!id || !project) {
    return (
      <div className="flex flex-row justify-center text-blue-800">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="size-32 animate-spin"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
          />
        </svg>
      </div>
    )
  }

  return (
    <ProjectView
      project={project}
      items={samples === null || samples === undefined ? [] : samples}
      participants={participants}
      orders={orders}
    />
  )
}
